import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "flex flex-col relative p-6 pb-0 gap-y-4",
  style: {"max-height":"calc(65vh / var(--viewport-scale)) !important"}
}
const _hoisted_2 = { class: "text-black-lp-300 text-base font-semibold text-center" }
const _hoisted_3 = { class: "border border-gray-lp-400 rounded-lg py-2 px-2 grid grid-cols-3 divide-x divide-gray-lp-400" }
const _hoisted_4 = { class: "flex flex-col items-center" }
const _hoisted_5 = { class: "text-black-lp-300 text-sm" }
const _hoisted_6 = { class: "text-black-lp-300 text-base font-semibold" }
const _hoisted_7 = { class: "flex flex-col items-center" }
const _hoisted_8 = { class: "text-black-lp-300 text-sm" }
const _hoisted_9 = { class: "text-black-lp-300 text-base font-semibold" }
const _hoisted_10 = { class: "flex flex-col items-center" }
const _hoisted_11 = { class: "text-black-lp-300 text-sm" }
const _hoisted_12 = { class: "text-black-lp-300 text-base font-semibold" }
const _hoisted_13 = { class: "flex items-center gap-x-4 justify-between w-full px-6 py-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectCustomerV2 = _resolveComponent("SelectCustomerV2")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_SendInvoiceReceiverRows = _resolveComponent("SendInvoiceReceiverRows")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_InvoicePdfStruk = _resolveComponent("InvoicePdfStruk")!
  const _component_InvoicePdfA4 = _resolveComponent("InvoicePdfA4")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Dialog, {
      modelValue: _ctx.visible,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.visible = $event)),
      header: false,
      persistent: "",
      customBody: "p-0",
      showOverflow: false,
      customWidth: "w-1/2"
    }, {
      "main-footer": _withCtx(() => [
        _createVNode("div", _hoisted_13, [
          _createVNode(_component_LpButton, {
            textColor: "red-lp-100",
            color: "red-lp-100",
            outline: "",
            title: _ctx.$t('bookingV4.previewInvoice.cancel'),
            isWidthFull: "",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.visible = false))
          }, null, 8, ["title"]),
          _createVNode(_component_LpButton, {
            color: "red-lp-100",
            textColor: "white",
            title: _ctx.$t('bookingV4.previewInvoice.createInvoice'),
            isWidthFull: "",
            onClick: _ctx.onCreate,
            disabled: _ctx.disabled
          }, null, 8, ["title", "onClick", "disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("bookingV4.previewInvoice.title")), 1),
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("bookingV4.previewInvoice.totalStt")), 1),
              _createVNode("span", _hoisted_6, _toDisplayString(_ctx.invoiceSummaryData.total), 1)
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("bookingV4.previewInvoice.totalTariff")), 1),
              _createVNode("span", _hoisted_9, _toDisplayString(_ctx.invoiceSummaryData.tariff), 1)
            ]),
            _createVNode("div", _hoisted_10, [
              _createVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("bookingV4.previewInvoice.totalInvoice")), 1),
              _createVNode("span", _hoisted_12, _toDisplayString(_ctx.invoiceSummaryData.amount), 1)
            ])
          ]),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('bookingV4.previewInvoice.billedTo'),
            class: "w-full"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SelectCustomerV2, {
                placeholder: _ctx.$t('bookingV4.previewInvoice.billedToPlaceholder'),
                customerName: _ctx.form.billedTo,
                "onUpdate:customerName": [
                  _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.billedTo = $event)),
                  _ctx.onChangeName
                ],
                loading: _ctx.loadingCustomerList,
                options: _ctx.customerList,
                keyName: "customerPhoneNumber",
                class: "mt-1.5",
                error: false,
                editable: false,
                useInfiniteScroll: "",
                onScrolled: _ctx.onScroll,
                onFocus: _ctx.onFocusCustomer,
                onSelect: _ctx.onSelectCustomer
              }, null, 8, ["placeholder", "customerName", "loading", "options", "onScrolled", "onUpdate:customerName", "onFocus", "onSelect"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            label: _ctx.$t('bookingV4.previewInvoice.note'),
            optional: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LpInput, {
                type: "textarea",
                placeholder: _ctx.$t('bookingV4.previewInvoice.notePlaceholder'),
                modelValue: _ctx.form.note,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.note = $event)),
                maxLength: 255
              }, null, 8, ["placeholder", "modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode("div", null, [
            _createVNode(_component_SendInvoiceReceiverRows, {
              viaOptions: _ctx.viaOptions,
              formatOptions: _ctx.formatOptions,
              onUpdate: _ctx.onReceiversUpdate,
              maxHeight: "200px",
              maxItemOverflow: 3,
              optional: ""
            }, null, 8, ["viaOptions", "formatOptions", "onUpdate"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_InvoicePdfStruk, {
      ref: "struk",
      invoiceData: _ctx.invoiceDetail.header,
      items: _ctx.invoiceDetail.items
    }, null, 8, ["invoiceData", "items"]),
    _createVNode(_component_InvoicePdfA4, {
      ref: "invoice",
      invoiceData: _ctx.invoiceDetail.header,
      items: _ctx.invoiceDetail.items
    }, null, 8, ["invoiceData", "items"])
  ], 64))
}